import React from 'react';
import { Box, Typography, Paper, Divider, Stack, Button, Grid } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import EditIcon from '@mui/icons-material/Edit';

const EntityView = ({
  title,
  sections,
  navigateBack,
  onEdit
}) => {
  return (
    <Box sx={{ px: { xs: 2, sm: 6 }, pt: 3, pb: 6, maxWidth: '880px', width: { xs: '-webkit-fill-available', md: '100%' }, margin: '0 auto' }}>
      {/* Header avec boutons */}
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        sx={{ mb: 3 }}
      >
        <Button
          variant="outlined"
          color="black"
          startIcon={<ArrowBackIcon />}
          onClick={navigateBack}
          sx={{ fontWeight: 500 }}
        >
          Retour
        </Button>
        {onEdit && (
          <Button
            variant="contained"
            startIcon={<EditIcon />}
            onClick={onEdit}
            sx={{ fontWeight: 500 }}
          >
            Éditer
          </Button>
        )}
      </Stack>

      {/* Titre principal */}
      <Typography variant="h3" sx={{ mb: 4, fontWeight: 600 }}>
        {title}
      </Typography>

      {/* Sections */}
      <Grid container spacing={3}>
        {sections.map((section, sectionIndex) => (
          <Grid item xs={12} key={sectionIndex}>
            <Paper
              elevation={0}
              sx={{
                p: { xs: 2.5, sm: 3 },
                border: '1px solid #E0E0E0',
                borderRadius: 2,
                backgroundColor: '#FAFAFA'
              }}
            >
              <Typography
                variant="h5"
                sx={{
                  mb: 2.5,
                  fontWeight: 600,
                  color: 'text.primary'
                }}
              >
                {section.title}
              </Typography>
              <Divider sx={{ mb: 2.5 }} />

              <Grid container spacing={2}>
                {section.fields.map((field, fieldIndex) => (
                  <Grid item xs={12} sm={6} key={fieldIndex}>
                    <Box
                      sx={{
                        p: 2,
                        backgroundColor: 'white',
                        borderRadius: 1,
                        border: '1px solid #F0F0F0',
                        minHeight: '70px',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center'
                      }}
                    >
                      <Typography
                        variant="body2"
                        sx={{
                          fontWeight: 600,
                          color: 'text.secondary',
                          mb: 0.5,
                          fontSize: '0.875rem'
                        }}
                      >
                        {field.label}
                      </Typography>
                      <Typography
                        variant="body1"
                        sx={{
                          fontWeight: 500,
                          color: 'text.primary',
                          fontSize: '1rem'
                        }}
                      >
                        {field.value || 'Non renseigné'}
                      </Typography>
                    </Box>
                  </Grid>
                ))}
              </Grid>
            </Paper>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default EntityView;
